export default __webpack_public_path__ + "static/payment-6632220524740e99880ef21240da3416.png";